"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Refresh = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Refresh = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "refresh", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "refresh", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M9 17c0-3.873 3.126-7 6.966-7a6.9 6.9 0 0 1 3.562.983L18.311 12.2c-.664.664-.194 1.8.745 1.8h5.89c.582 0 1.054-.472 1.054-1.054v-5.89c0-.939-1.136-1.41-1.8-.745L22.411 8.1A10.902 10.902 0 0 0 15.966 6C9.903 6 5 10.932 5 17s4.903 11 10.966 11c4.313 0 8.036-2.497 9.826-6.113a2 2 0 0 0-3.584-1.774A6.963 6.963 0 0 1 15.966 24C12.126 24 9 20.873 9 17Z", fill: "#172344", fillRule: "evenodd" }) })) })));
};
exports.Refresh = Refresh;
